// useGlobalInspector.ts - Store Zustand para Inspector Global
// Bigwa v7.0 - Janeiro 2026

import { create } from 'zustand';
import { Work } from '../types/work';

export type InspectorTab = 'info' | 'actions' | 'related';

export interface InspectorItem {
  type: 'work' | 'project' | 'data' | 'highlight';
  id: string;
  data: unknown;
}

interface GlobalInspectorState {
  // Visibility
  isOpen: boolean;
  isExpanded: boolean;
  
  // Current item
  selectedItem: InspectorItem | null;
  
  // Active tab
  activeTab: InspectorTab;
  
  // Actions
  open: () => void;
  close: () => void;
  toggle: () => void;
  expand: () => void;
  collapse: () => void;
  toggleExpand: () => void;
  
  // Item selection
  selectItem: (item: InspectorItem) => void;
  selectWork: (work: Work) => void;
  clearSelection: () => void;
  
  // Tab navigation
  setTab: (tab: InspectorTab) => void;
}

export const useGlobalInspector = create<GlobalInspectorState>((set, _get) => ({
  // Initial state
  isOpen: true,
  isExpanded: false,
  selectedItem: null,
  activeTab: 'info',
  
  // Visibility actions
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
  toggle: () => set(state => ({ isOpen: !state.isOpen })),
  
  expand: () => set({ isExpanded: true }),
  collapse: () => set({ isExpanded: false }),
  toggleExpand: () => set(state => ({ isExpanded: !state.isExpanded })),
  
  // Item selection
  selectItem: (item) => set({
    selectedItem: item,
    activeTab: 'info'
  }),

  selectWork: (work) => set({
    selectedItem: {
      type: 'work',
      id: work.id,
      data: work
    },
    activeTab: 'info'
  }),
  
  clearSelection: () => set({ 
    selectedItem: null,
    isExpanded: false 
  }),
  
  // Tab navigation
  setTab: (tab) => set({ activeTab: tab }),
}));

export default useGlobalInspector;
